import { PageLayout } from '@kizi/comparator-core';
import { faqItems } from '../../../content/healthModalsContent';
import { allPoliciesLabels } from '../../../utils/helperFunctions';

const productComparisonLayout: PageLayout = {
  name: 'productComparison',
  components: [
    {
      type: 'ComparisonPage',
      props: {
        comparisonProducts: 'overview.comparisonProducts',
        contentStyles: {
          span: [12, 12, 12, 12],
        },
        noComparisonNavigationIndex: 2,
        bg: 'comparatorBG',
        header: [
          {
            type: 'PageHeader',
            props: {
              faq: {
                buttonLabel: 'Veelgestelde vragen',
                buttonIcon: 'comment',
                title: 'Veelgestelde vragen',
                items: faqItems,
                hideLabelOnMobile: true,
              },
              activeStep: 1,
            },
          },
          {
            type: 'ComparisonStickyHeader',
          },
        ],
        subHeader: [
          {
            type: 'Heading',
            props: {
              variant: 'H2',
              as: 'h2',
              children: 'Vergelijken',
            },
          },
          {
            type: 'GoToButtonIcon',
            props: {
              variant: 'transparentWithIcon',
              index: 2,
              children: 'Terug naar overzicht',
            },
          },
        ],
        content: [
          {
            type: 'ExperienceManager',
            props: {
              label: 'Draai je telefoon voor een betere ervaring',
            },
            _children: [
              {
                type: 'ComparisonPageRequestWrapper',
                _children: [],
              },
              {
                type: 'ProductComparisonContainerWrapper',
                props: {
                  additionalFields: ['overview.filters'],
                  labels: [
                    {
                      label: '',
                    },
                    {
                      label: 'Type verzekering',
                      tooltip:
                        'Er zijn 4 verschillende soorten basisverzekeringen; Met een restitutiepolis heb je de meeste keuzevrijheid in zorgverleners en met een budgetpolis de minste. Daartussen zitten de combinatiepolis en naturapolis.',
                    },
                    {
                      label: 'Premie opbouw',
                    },
                    {
                      label: 'Scores',
                      tooltip:
                        'Overstappen.nl beoordeelt de zorgverzekeraars op polisvoorwaarden en zorginkoop. Tezamen vormt dit het kwaliteitsoordeel. Daarnaast beoordelen wij op duurzaamheid.',
                    },
                    {
                      label: 'Polisvoorwaarden',
                    },
                    {
                      label: '',
                    },
                  ],
                  comparator: 'os-health',
                  section: 'overview',
                  goToIndex: 2,
                },
              },
              {
                type: 'ProductComparisonContainerWrapper',
                props: {
                  additionalFields: ['overview.filters'],
                  header: 'Kenmerken',
                  labels: [
                    {
                      label: 'Onderdeel van',
                      tooltip:
                        'Veel zorgverzekeraars zijn onderdeel van een groter concern. Hier zie je bij welke\n' +
                        'zorgverzekeraar de gekozen zorgverzekeraar hoort.',
                    },
                    {
                      label: 'Basisverzekering',
                      tooltip:
                        'De basisverzekering is een verplichte verzekering. Hierin is alle medisch noodzakelijk zorg opgenomen die niet zelf te betalen is. De inhoud van de basisverzekering is bij iedere zorgverzekeraar gelijk en wordt vastgesteld door de overheid.',
                    },
                    {
                      label: 'Aanvullende verzekering',
                      tooltip:
                        'Naast de basisverzekering kun je een aanvullende verzekering afsluiten.Vaak gebeurt dit voor mondzorg, fysiotherapie of alternatieve geneeswijzen.',
                    },
                    {
                      label: 'Type verzekering',
                      tooltip:
                        'Er zijn 4 verschillende soorten basisverzekeringen; Met een restitutiepolis heb je de meeste keuzevrijheid in zorgverleners en met een budgetpolis de minste. Daartussen zitten de combinatiepolis en naturapolis.',
                    },
                    {
                      label: 'Ziekenhuiskeuze',
                      tooltip:
                        'Niet met alle verzekeringen kun je naar alle ziekenhuizen voor een geplande behandeling. Voor spoedeisende hulp kun je wel altijd naar alle ziekenhuizen.',
                    },
                    {
                      label: 'Eigen risico',
                      tooltip:
                        'Voor de basisverzekering heb je een verplicht eigen risico, meestal €385. Dit is het bedrag dat je zelf betaalt, voordat je zorgverzekeraar zorgkosten vergoedt. Verhoog je je eigen risico? Dan gaat je premie omlaag.',
                    },
                    {
                      label: 'Directe acceptatie',
                      tooltip:
                        'Voor de aanvullende verzekering geldt er niet altijd een directe acceptatie. Het kan voorkomen dat de zorgverzekeraar je nog een aantal vragen stelt over je gezondheid of gebit. ',
                    },
                    {
                      label: 'Wachttijd',
                      tooltip:
                        'Een aantal aanvullende verzekeringen hebben een wachttijd. Vaak is dit voor orthodontie of dure tandartsbehandelingen. Als er een wachttijd is dan kun je niet direct gebruik maken van de dekking. Je moet meestal eerst een jaar verzekerd zijn voor dat pakket.',
                    },
                  ],
                  comparator: 'os-health',
                  section: 'characteristics',
                },
              },
              {
                type: 'CoverageComparisonWrapper',
                props: {
                  header: 'Jouw aanvulllende dekkingen',
                  comparator: 'os-health',
                  section: 'additionalCoverages',
                },
              },
              {
                type: 'ComparisonPageRequestWrapper',
                _children: [
                  {
                    type: 'CoverageComparisonWrapper',
                    props: {
                      header: 'Aanvullende dekkingen',
                      dynamicLabelsFn: allPoliciesLabels,
                      labels: [],
                      comparator: 'os-health',
                      section: 'extraAdditionalCoverages',
                    },
                  },
                ],
              },
              {
                type: 'ProductComparisonContainerWrapper',
                props: {
                  header: 'Voorwaarden',
                  labels: [
                    {
                      label: 'Documenten',
                    },
                  ],
                  comparator: 'os-health',
                  section: 'documents',
                },
              },
            ],
          },
        ],
        affiliateUrlClientId: 'overstappen',
        affiliatePageDescriptor: {
          type: 'AffiliateUrlModalWrapper',
        },
      },
    },
  ],
};

export default productComparisonLayout;
